import type { ReactNode } from "react";
import type { PortalFeatureKey } from "@wwrp/shared";
import { Alert } from "@mantine/core";
import { usePortalFeatures } from "../hooks/usePortalFeatures.js";

export function PortalFeatureGuard({
  feature,
  children,
}: {
  feature: PortalFeatureKey;
  children: ReactNode;
}) {
  const query = usePortalFeatures();
  // Keep the page usable while settings load or if the feature settings table is unavailable.
  // Missing settings default to enabled; a known disabled value still blocks the page below.
  if (query.isLoading || query.isError || !query.data) return children;
  if (query.data?.features[feature] === false) {
    return (
      <Alert color="gray" title="This feature is turned off">
        An administrator has turned off this section.
      </Alert>
    );
  }
  return children;
}
